module.exports = __webpack_public_path__ + "static/media/lb.771af684.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/lb.png
// module id = 1905
// module chunks = 0